import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class HttpClientSkippingInterceptorsService extends HttpClient {
    constructor(
        private httpBackend: HttpBackend,
        private authenticationService: AuthenticationService
    ) {
        super(httpBackend);
    }

    getAuthHeaders() {
        return new HttpHeaders({ 'x-access-token': this.authenticationService.token });
    }
}
